/* eslint-disable prefer-rest-params */
import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { barChartOptions } from "./config";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend
);

const Bar = ({ data, shadow = false }) => {
  const chartContainer = useRef(null);
  const [, setChartInstance] = useState(null);

  useEffect(() => {
    if (chartContainer && chartContainer.current) {
      if (shadow) {
        // Register custom controller for bar chart with shadow
        class BarWithShadowController extends BarController {
          draw() {
            const { ctx } = this.chart;
            ctx.save();
            ctx.shadowColor = "rgba(0,0,0,0.2)";
            ctx.shadowBlur = 7;
            ctx.shadowOffsetX = 5;
            ctx.shadowOffsetY = 7;
            super.draw();
            ctx.restore();
          }
        }
        
        BarWithShadowController.id = "barWithShadow";
        BarWithShadowController.defaults = BarController.defaults;
        
        ChartJS.register(BarWithShadowController);
      }
      
      const context = chartContainer.current.getContext("2d");
      const newChartInstance = new ChartJS(context, {
        type: shadow ? "barWithShadow" : "bar",
        options: barChartOptions,
        data,
      });
      setChartInstance(newChartInstance);
      
      // Cleanup function to destroy chart instance
      return () => {
        if (newChartInstance) {
          newChartInstance.destroy();
        }
      };
    }
  }, [chartContainer, data, shadow]);

  return <canvas ref={chartContainer} />;
};

export default Bar;
